import React, { useEffect, useState } from "react";
import { Pagination, Scrollbar } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { v4 as uuidv4 } from "uuid";
import { ReactComponent as MenuStar } from "../components/imgComponents/menu-star.svg";
import "swiper/css";
import "swiper/css/scrollbar";
import "../css/slider.scss";
import CTA from "./CTA";

const slider_pagination = [
  "Before Black Friday <span class='font-regular'>Sep & Oct</span>",
  "During Black Friday <span class='font-regular'>Nov</span>",
  "After Black Friday <span class='font-regular'>Dec & beyond</span>",
];
const pages = ["before", "during", "after"];

const MobileSwiper = (props) => (
  <section className="slider">
    <h2 data-aos="fade-in">
      <span>{props.gallery_pre_title}</span>
      {props.gallery_title}
    </h2>
    <div className="mobile-swiper-container">
      <div className="swiper-custom-pagination"></div>
      <Swiper
        className="main-swiper"
        modules={[Pagination, Scrollbar]}
        spaceBetween={50}
        slidesPerView={1}
        pagination={{
          clickable: true,
          el: ".swiper-custom-pagination",
          renderBullet: (index, className) => {
            return '<span class="' + className + '">' + slider_pagination[index] + "</span>";
          },
        }}
        scrollbar={{ draggable: true }}
      >
        {Object.entries(props.gallery).map((slide, index) => (
          <SwiperSlide key={uuidv4()}>
            <Swiper
              className="inner-swiper"
              modules={[Pagination]}
              spaceBetween={50}
              slidesPerView={1}
              breakpoints={{
                768: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
              pagination={{
                clickable: true,
                el: ".swiper-inner-pagination",
              }}
            >
              {slide[1].assets_gallery.map((asset, index) => (
                <SwiperSlide key={uuidv4(index)}>
                  <CTA
                    href={asset["link"]}
                    className="inner-link"
                    withChildren={true}
                    segmentLocation="Posts"
                    title={asset["text"]}
                    segmentBtnName={`BFCM posts`}
                  >
                    <img data-aos="fade-up" src={asset["image_group"]["1x"]} alt={asset["image_group"]["alt"]} />
                    <div className="slide-content">
                      <span>{asset["asset_type"]}</span>
                      <p>{asset["text"]}</p>
                    </div>
                  </CTA>
                </SwiperSlide>
              ))}
              <div className="swiper-inner-pagination"></div>
            </Swiper>
            <div className="cta-wrapper">
              <CTA
                href={"/" + pages[index]}
                title="See more"
                segmentLocation="Timeline"
                segmentBtnName={`${pages[index]} BFCM`}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  </section>
);

const DesktopSwiper = (props) => {
  const [isHovering, setIsHovering] = useState(0);

  const handleMouseOver = (i) => {
    setIsHovering(i);
  };

  const setActive = () => {
    document.querySelector(".desktop-gallery-slide").classList.add("active");
  };

  useEffect(() => {
    setActive();
  }, []);

  return (
    <div className="desktop-gallery-container">
      <div className="desktop-gallery">
        {Object.entries(props.gallery).map((slide, index) => (
          <div className={"desktop-gallery-wrap" + (isHovering === index ? " active" : "")} key={index}>
            <MenuStar className="bigStar star" />
            <div
              key={index}
              className={"desktop-gallery-slide" + (isHovering === index ? " active" : "")}
              onMouseOver={() => {
                handleMouseOver(index);
              }}
            >
              <div className="header-content">
                <span dangerouslySetInnerHTML={{ __html: slider_pagination[index] }}></span>
                <CTA
                  href={"/" + pages[index]}
                  title="See more"
                  segmentLocation="Timeline"
                  segmentBtnName={`${pages[index]} BFCM`}
                />
              </div>
              <div className="desktop-gallery-slide-content">
                {slide[1].assets_gallery.map((asset, i) => (
                  <div key={i} data-aos="fade" data-aos-delay={100 * index} className="desktop-gallery-slide-item">
                    <MenuStar className="smallStar star" />
                    <CTA
                      href={asset["link"]}
                      className="inner-link"
                      withChildren={true}
                      segmentLocation="Timeline post"
                      title={asset["text"]}
                      segmentBtnName={`BFCM posts`}
                    >
                      <img src={asset["image_group"]["1x"]} alt={asset["image_group"]["alt"]} />
                      <div className="slide-content">
                        <span>{asset["asset_type"]}</span>
                        <p className="font-regular">{asset["text"]}</p>
                      </div>
                    </CTA>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Slider = (props) => {
  return (
    <div className="slider-section">
      <MobileSwiper {...props} />
      <DesktopSwiper {...props} />
    </div>
  );
};

export default Slider;
